/**
 * Global Cart Handler - Spoločné funkcie pre košík
 * Používa sa na všetkých stránkach pre konzistentné správanie
 */

// Po AJAX pridaní do košíka znovu načíta bublinu v hlavičke a obsah draweru
function updateCartDrawer(cart) {
  fetch(`/cart?sections=cart-icon-bubble,cart-drawer`)
    .then(r => r.json())
    .then(sections => {
      const icon = document.getElementById('cart-icon-bubble');
      if (icon && sections['cart-icon-bubble']) {
        icon.innerHTML = sections['cart-icon-bubble'];
      }
      const drawer = document.getElementById('CartDrawer');
      if (drawer && sections['cart-drawer']) {
        drawer.innerHTML = sections['cart-drawer'];
      }
    })
    .catch(e => console.error('Chyba pri reloadovaní draweru:', e));
}

// Global cart update function
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count, .header-cart-count, [data-cart-count]');
      cartCountElements.forEach(el => {
        // vždy zobraz číslo, aj keď je 0
        el.textContent = cart.item_count;
        el.classList.remove('hidden');
        el.style.display = '';
      });

      // Update cart drawer if exists
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer && typeof updateCartDrawer === 'function') {
        updateCartDrawer(cart);
      }
    })
    .catch(error => console.error('Error updating cart:', error));
}

// Show notification function
function showNotification(message, type = 'success') {
  document.querySelectorAll('.cart-notification').forEach(n => n.remove());
  const notification = document.createElement('div');
  notification.className = `cart-notification cart-notification-${type}`;
  notification.innerHTML = `
    <div class="cart-notification-content">
      <div class="cart-notification-icon">
        ${type === 'success'
          ? '<svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>'
          : '<svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>'
        }
      </div>
      <span class="cart-notification-message">${message}</span>
      <button class="cart-notification-close" onclick="this.closest('.cart-notification').remove()">×</button>
    </div>
  `;
  if (!document.getElementById('cart-notification-styles')) {
    const styles = document.createElement('style');
    styles.id = 'cart-notification-styles';
    styles.textContent = `
      .cart-notification { position: fixed; top:20px; right:20px; z-index:10000; max-width:400px; border-radius:12px; box-shadow:0 10px 25px -3px rgba(0,0,0,0.1); animation:slideInCart 0.3s ease; backdrop-filter:blur(10px); }
      .cart-notification-success { background:rgba(209,250,229,0.95); border:2px solid #22c55e; color:#15803d; }
      .cart-notification-error { background:rgba(254,226,226,0.95); border:2px solid #ef4444; color:#dc2626; }
      .cart-notification-content { padding:16px 20px; display:flex; align-items:center; gap:12px; }
      .cart-notification-icon { flex-shrink:0; }
      .cart-notification-message { font-weight:600; font-size:1rem; flex:1; }
      .cart-notification-close { background:none; border:none; font-size:1.5rem; cursor:pointer; color:inherit; opacity:0.7; transition:opacity 0.3s ease; flex-shrink:0; }
      .cart-notification-close:hover { opacity:1; }
      @keyframes slideInCart { from { transform:translateX(100%); opacity:0; } to { transform:translateX(0); opacity:1; } }
      @media(max-width:768px){ .cart-notification{ top:10px; right:10px; left:10px; max-width:none; } }
    `;
    document.head.appendChild(styles);
  }
  document.body.appendChild(notification);
  setTimeout(() => {
    if (notification.parentElement) {
      notification.style.animation = 'slideInCart 0.3s ease reverse';
      setTimeout(() => notification.remove(), 300);
    }
  }, 4000);
}

// Add to cart function
function addToCart(variantId, quantity = 1, productTitle = '') {
  return new Promise((resolve, reject) => {
    const buttons = document.querySelectorAll(`[data-variant-id="${variantId}"]`);
    const originalStates = [];
    buttons.forEach(button => {
      originalStates.push({ button, originalContent: button.innerHTML, originalDisabled: button.disabled });
      button.innerHTML = '<svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" opacity="0.3"/><path d="M12 2 L12 8" stroke="currentColor" stroke-width="4" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/></path></svg>';
      button.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    })
    .then(res => res.ok ? res.json() : Promise.reject(res.statusText))
    .then(data => {
      const title = productTitle || (data.items?.[0]?.product_title || 'Produkt');
      showNotification(`${title} bol pridaný do košíka!`, 'success');
      updateCartCount();
      originalStates.forEach(({ button, originalContent, originalDisabled }) => {
        button.innerHTML = originalContent;
        button.disabled = originalDisabled;
      });
      resolve(data);
    })
    .catch(error => {
      console.error('Error:', error);
      showNotification('Chyba pri pridávaní do košíka', 'error');
      originalStates.forEach(({ button, originalContent, originalDisabled }) => {
        button.innerHTML = originalContent;
        button.disabled = originalDisabled;
      });
      reject(error);
    });
  });
}

// Quick view function
function quickViewProduct(productUrl) {
  window.open(productUrl, '_blank');
}

// Initialize cart functionality
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-variant-id]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      addToCart(
        btn.getAttribute('data-variant-id'),
        parseInt(btn.getAttribute('data-quantity')) || 1,
        btn.getAttribute('data-product-title') || ''
      );
    }
  });

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-product-url]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      quickViewProduct(btn.getAttribute('data-product-url'));
    }
  });

  updateCartCount();
});

// Export for global use
window.cartHandler = {
  addToCart,
  updateCartCount,
  showNotification,
  quickViewProduct
};
